module.exports = __webpack_public_path__ + "static/img/home_cn_solution2.60f0c51.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/home_cn_solution2.png
// module id = ux+C
// module chunks = 0